var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5016,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9297,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3578,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.786,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2139,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.642,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.07,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 1.5016,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 23.9297,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 46.3579,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 68.786,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 91.2141,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 113.642,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 136.07,
    r: 1.5016,
    fill: "#1A2236"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.498,
    cy: 158.498,
    r: 1.5016,
    fill: "#1A2236"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDots);
export default __webpack_public_path__ + "static/media/image_dots.ed6152b1166c60fd721ba922928e1d09.svg";
export { ForwardRef as ReactComponent };